
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeveloperComponent } from './developer.component';
import { DeveloperRoutingModule } from './developer-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { LoadingModule } from 'ngx-loading';
import { PipesModule } from '../core/pipes/pipes.module';
import { FileImportComponent } from './file-import/file-import.component';
import { FileUploadModule } from 'ng2-file-upload';
import { TestExternalLoginComponent } from './components/test-external-login/test-external-login.component';
import { TextMaskModule } from 'angular2-text-mask';
import { ServiceSubscriptionEditorComponent } from './components/service-subscription-editor/service-subscription-editor.component';
import { ServiceSubscriptionEditorService } from './components/service-subscription-editor/service-subscription-editor.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { SignalRTestComponent } from './components/developer-tools/signalr-test/signalr-test.component';
import { FailedLoginsComponent } from './auth-tools/failed-logins/failed-logins.component';
import { AuthToolsService } from './auth-tools/auth-tools.service';
import { AuthToolsComponent } from './auth-tools/auth-tools.component';
import { SetUserPasswordComponent } from './auth-tools/set-user-password/set-user-password.component';
import { HangfireDashboardComponent } from './hangfire-dashboard/hangfire-dashboard.component';
import { LogsComponent } from './logs/logs.component';
import { AuthLogsComponent } from './logs/auth-logs/auth-logs.component';
import { AuthLogsService } from './logs/auth-logs/auth-logs.service';
import { JobLogsComponent } from './logs/job-logs/job-logs.component';
import { JobLogsService } from './logs/job-logs/job-logs.service';
import { JobLogDetailModalComponent } from './logs/job-logs/job-log-detail-modal/job-log-detail-modal.component';
import { ReportingComponent } from './reporting/reporting.component';
import { ReportDesignerComponent } from './reporting/report-designer/report-designer.component';
import { ServiceRatesComponent } from './components/service-rates/service-rates.component';
import { FeatureFlagsComponent } from './feature-flags/feature-flags.component';
import { SafteyComponent } from './components/developer-tools/safety/safety.component';
import { RecoveryAssetsComponent } from './components/developer-tools/recovery-assets/recovery-assets.component';
import { WebsiteInfoComponent } from './system-settings/website-info/website-info.component';
import { ACHComponent } from './system-settings/ach/ach.component';
import { APITestingComponent } from './third-party/api-testing/api-testing.component';
import { HubSpotSandboxToggleComponent } from './components/hubspot-sandbox-toggle/hubspot-sandbox-toggle.component';
import { ScheduledJobsComponent } from './components/developer-tools/scheduled-jobs/scheduled-jobs.component';
// The WinFactor to FactorCloud conversion page lives under Dev Tools (its files are still in portal/conversion).
import { ConversionComponent } from '../portal/conversion/conversion.component';
import { ConversionDetailModalComponent } from '../portal/conversion/conversion-detail-modal/conversion-detail-modal.component';
import { MigrationProgressModalComponent } from '../portal/conversion/migration-progress-modal/migration-progress-modal.component';
import { ConversionService } from '../portal/conversion/conversion.service';
import { ConversionDataUploadComponent } from '../portal/conversion/data-upload/conversion-data-upload.component';
import { CreateCheckListsComponent } from './components/developer-tools/create-checklists/create-checklists.component';
import { EOMProcessingComponent } from './components/developer-tools/eom-processing/eom-processing.component';
import { LoggingTestsComponent } from './components/developer-tools/logging-tests/logging-tests.component';
import { AuthTestsComponent } from './components/developer-tools/auth-tests/auth-tests.component';
import { ReportViewerComponent } from './reporting/report-viewer/report-viewer.component';
import { ReportTypeEditorComponent } from './components/developer-tools/report-type-editor/report-type-editor.component';
import { ReportTypeEditorItemComponent } from './components/developer-tools/report-type-editor/report-type-editor-item/report-type-editor-item.component';
import { ReportCategoryNameModalComponent } from './components/developer-tools/report-type-editor/report-category-name-modal/report-category-name-modal.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = { suppressScrollX: true };

@NgModule({
  imports: [
    CommonModule,
    DeveloperRoutingModule,
    SharedModule,
    CoreModule,
    PerfectScrollbarModule,
    NgbModule.forRoot(),
    MultiselectDropdownModule,
    NgxDatatableModule,
    NgbDatepickerModule,
    ReactiveFormsModule,
    NgxChartsModule,
    PipesModule,
    LoadingModule,
    FormsModule,
    FileUploadModule,
    TextMaskModule,
    NgSelectModule,
  ],
  declarations: [
    SignalRTestComponent,
    DeveloperComponent,
    FileImportComponent,
    TestExternalLoginComponent,
    ServiceSubscriptionEditorComponent,
    FailedLoginsComponent,
    AuthToolsComponent,
    SetUserPasswordComponent,
    HangfireDashboardComponent,
    LogsComponent,
    AuthLogsComponent,
    JobLogsComponent,
    JobLogDetailModalComponent,
    ReportingComponent,
    ReportDesignerComponent,
    ReportViewerComponent,
    ServiceRatesComponent,
    FeatureFlagsComponent,
    SafteyComponent,
    RecoveryAssetsComponent,
    WebsiteInfoComponent,
    ACHComponent,
    APITestingComponent,
    HubSpotSandboxToggleComponent,
    ScheduledJobsComponent,
    ConversionComponent,
    ConversionDetailModalComponent,
    MigrationProgressModalComponent,
    ConversionDataUploadComponent,
    CreateCheckListsComponent,
    EOMProcessingComponent,
    LoggingTestsComponent,
    AuthTestsComponent,
    ReportTypeEditorComponent,
    ReportTypeEditorItemComponent,
    ReportCategoryNameModalComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    AuthToolsService,
    ServiceSubscriptionEditorService,
    AuthLogsService,
    JobLogsService,
    ConversionService,
  ]
})
export class DeveloperModule { }



// WEBPACK FOOTER //
// ./src/app/developer/developer.module.ts